import { PART_URL_GOOGLE_MAP_PLACE, GOOGLE_API_VERSION, MAILTO_PREFIX, TEL_PREFIX, } from './constants';
/**
 * @param destination - end point of destination
 * @param myLocation - string or undefined - secondary priority
 * @param startingPlace - string or null/undefined - more priority prop then 'myLocation' prop
 * @returns to get site url google.map (string)
 */
export function getDirectionLink({ destination, myLocation, startingPlace, }) {
    if (startingPlace) {
        return `${PART_URL_GOOGLE_MAP_PLACE}/${startingPlace}/${destination}`;
    }
    const originParam = myLocation ? `origin:${myLocation}` : '';
    const qParameters = [
        GOOGLE_API_VERSION,
        originParam,
        `destination=${destination}`,
        'travelmode=driving',
        'map_action=map',
    ].join('&');
    return `${PART_URL_GOOGLE_MAP_PLACE}/?${qParameters}`;
}
export function getEmailAddress(email) {
    return `${MAILTO_PREFIX}:${email}`;
}
export function getPhoneNumbers(phones) {
    const firstPhone = phones[0];
    return {
        link: `${TEL_PREFIX}:${firstPhone}`,
        value: firstPhone,
    };
}
